<template>
  <div class="container">
  <div class="row">
    <h1>Administração</h1>
    <hr>
    <loader v-if="loading"></loader>
    <div class="col-lg-3 col-md-6" v-if="isAdminRequests">
      <div class="panel panel-default">
        <router-link to="/requests" id="admin-requests">
          <div class="panel-heading">
              <div class="row">
                  <div class="col-xs-3">
                      <i class="glyphicon glyphicon-duplicate"></i>
                  </div>
                  <div class="col-xs-9 text-right">
                      <div class="huge">Requisições</div>
                      <div></div>
                  </div>
              </div>
          </div>
        </router-link>
      </div>
    </div>
    <div class="col-lg-3 col-md-6" v-if="isAdminRequestTypes">
      <div class="panel panel-default">
        <router-link to="/requestTypes" id="admin-request-types">
          <div class="panel-heading">
              <div class="row">
                  <div class="col-xs-3">
                      <i class="glyphicon glyphicon-list-alt"></i>
                  </div>
                  <div class="col-xs-9 text-right">
                      <div class="huge">Tipos de Requisição</div>
                      <div></div>
                  </div>
              </div>
          </div>
        </router-link>
      </div>
    </div>
    <div class="col-lg-3 col-md-6" v-if="isAdminWorkflows">
      <div class="panel panel-default">
        <router-link to="/workflows" id="admin-workflows">
          <div class="panel-heading">
              <div class="row">
                  <div class="col-xs-3">
                      <i class="glyphicon glyphicon-log-in"></i>
                  </div>
                  <div class="col-xs-9 text-right">
                      <div class="huge">Workflows</div>
                      <div></div>
                  </div>
              </div>
          </div>
        </router-link>
      </div>
    </div>
    <div class="col-lg-3 col-md-6" v-if="isAdminGroups">
      <div class="panel panel-default">
        <router-link to="/groups" id="admin-groups">
          <div class="panel-heading">
              <div class="row">
                  <div class="col-xs-3">
                      <i class="glyphicon glyphicon-th-large"></i>
                  </div>
                  <div class="col-xs-9 text-right">
                      <div class="huge">Grupos</div>
                      <div></div>
                  </div>
              </div>
          </div>
        </router-link>
      </div>
    </div>
    <div class="col-lg-3 col-md-6" v-if="isAdminUsers">
      <div class="panel panel-default">
        <router-link to="/users" id="admin-users">
          <div class="panel-heading">
              <div class="row">
                  <div class="col-xs-3">
                      <i class="glyphicon glyphicon-user"></i>
                  </div>
                  <div class="col-xs-9 text-right">
                      <div class="huge">Usuários</div>
                      <div></div>
                  </div>
              </div>
          </div>
        </router-link>
      </div>
    </div>
    <div class="alert alert-info" v-if="!loading && !isAdminRequests && !isAdminRequestTypes && !isAdminWorkflows && !isAdminGroups">
        Nenhum privilégio de administrador encontrado.
    </div>
  </div>
  </div>
</template>

<script>
import {
  Parse,
  miniToastr
} from '../Global'

import Loader from './util/Loader'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Loader,
    Multiselect
  },
  data () {
    return {
      loading: false,
      isAdminRequests: false,
      isAdminRequestTypes: false,
      isAdminWorkflows: false,
      isAdminGroups: false,
      isAdminUsers: false
    }
  },
  mounted () {
    this.checkPermissions()
  },
  methods: {
    checkPermissions () {
      let self = this
      self.loading = true
      let user = Parse.User.current()
      var queryRole = new Parse.Query(Parse.Role)
      queryRole.equalTo('users', user)
      queryRole.find().then(function (roles) {
        self.isAdminRequests = self.hasHole(roles, 'ADMIN_REQUESTS')
        self.isAdminRequestTypes = self.hasHole(roles, 'ADMIN_REQTYPE')
        self.isAdminWorkflows = self.hasHole(roles, 'ADMIN_WORKFLOW')
        self.isAdminGroups = self.hasHole(roles, 'ADMIN_GROUPS')
        self.isAdminUsers = self.hasHole(roles, 'ADMIN_USERS')
        self.loading = false
      }, function (error) {
        miniToastr.error(error.message)
        self.loading = false
      })
    },
    hasHole (roles, roleName) {
      let role = roles.find(r => r.get('name') === roleName)
      if (role) {
        return true
      }
      return false
    }
  }
}
</script>

<style>
i.glyphicon {
  font-size: 50px
}
</style>



// WEBPACK FOOTER //
// Management.vue?314b82fb